import { Avatar, AvatarFallback, AvatarImage } from '@src/design-system/avatar';
import { FilterOptionItem } from '@src/design-system/filter-new';
import type { TRenderOptionItemCtx } from '../../types/filter-config';
import type { TMember } from '@src/shared/types/member';

export function MembersFilterOptionItem({
  selected,
  item,
  onToggle,
}: TRenderOptionItemCtx<TMember>) {
  return (
    <FilterOptionItem
      selected={selected}
      onClick={onToggle}
      className='border border-pale-border p-2 mb-2 last:mb-0 rounded-lg'
    >
      <Avatar className='size-6'>
        <AvatarImage src={item.user.avatar} />
        <AvatarFallback>{item.user.first_name?.[0]}</AvatarFallback>
      </Avatar>
      <div className='flex flex-col min-w-0'>
        <span
          className='truncate'
          title={item.user.first_name}
        >
          {item.user.first_name} {item.user.last_name}
        </span>
        <span
          className='truncate text-gray-600 text-xs'
          title={item.user.email}
        >
          {item.user.email}
        </span>
      </div>
    </FilterOptionItem>
  );
}
